
import { Component, Vue } from "vue-property-decorator";

@Component
export default class ManualAdd extends Vue {

  prev() {
    this.$router.push({ name: "qa-upgrade-user" });
  }

  next() {
    this.$router.push({ name: "qa-unlock-user" });
  }

}
